import { render, staticRenderFns } from "./comp_Home-ProductsCarousel.vue?vue&type=template&id=63b84adb&scoped=true&"
import script from "./comp_Home-ProductsCarousel.vue?vue&type=script&lang=js&"
export * from "./comp_Home-ProductsCarousel.vue?vue&type=script&lang=js&"
import style0 from "./comp_Home-ProductsCarousel.vue?vue&type=style&index=0&id=63b84adb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b84adb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VIcon,VSpacer})
